<template>
  <div class="app-container">
    <!-- <h1>PDF.js 'Hello, world!' example</h1> -->
    <!-- <canvas id="the-canvas"></canvas> -->
    <iframe :src="url" class="iframe-pdf" />
  </div>
</template>

<!-- <script src="//mozilla.github.io/pdf.js/build/pdf.js"></script> -->

<script>

export default {
  name: 'pdf-preview',
  data() {
    return {
      // pdfURL: '/static/pdfjs/web/viewer.html?file=test.pdf'
      // pdfURL: ''
      url: '',
    }
  },

  props: {
    pdfURL: {
      type: String,
      required: true,
      // default: 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf'
    }
  },

  created() {
    // debugger
    this.loadPDF();
    // this.addEventListener();
  },

  /**
   * 禁止F12
   * 若更改代码后不刷新页面，有可能不起作用
   */
  // mounted() {
  //   this.$nextTick(() => {
  //     document.oncontextmenu = function () {
  //       return false;
  //     }
  //     document.οnkeydοwn = new Function('event.returnValue=false')
  //   })
  //   document.onkeydown = function(e) {
  //     if (e.key == 'F12') {
  //       return false;
  //     }
  //   }
  // },

  methods: {
    /**
     * 从后端获取申报书PDF的url
     */
    getPdfURL() {
      let baseurl = '';
      return baseurl;
    },

    /**
     * 加载PDF
     */
    loadPDF() {
      // let baseurl = 'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf';
      let pSrc = this.pdfURL + '?r=' + new Date();
      this.url = './static/pdfjs/web/viewer.html?file=' + encodeURIComponent(pSrc) + '.pdf';
    },

    addEventListener() {
      let iframe = this.$refs.iframe;
    }
  }
}
</script>

<style scoped>
#the-canvas {
  border: 1px solid black;
  direction: ltr;
}

.iframe-pdf {
  height: 700px;
  width: 100%;
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pdf-preview.vue